import React from "react";
import styles from './TemplateNone.module.scss'

const TemplateNone = () => {
  return (
    <div className={styles.conteiner}>
      <div className={styles.information}>
        Выберите один из предложенных шаблонов или создайте новый
      </div>
    </div>
  )
}

export default TemplateNone;